/*
 * Sdílený popup s obsahem Shopify stránky. Otevírá ho jakýkoli prvek s třídou .js-page-popup —
 * dnes odkaz na zásady zpracování OÚ pod newsletterem, klidně kdekoli jinde.
 *
 * Obsah se NENAČÍTÁ requestem: sekce ho vykreslí rovnou do <template>, který si prvek adresuje
 * v data-popup-template. Je tedy součástí payloadu stránky v aktuálním locale (Shopify vrací
 * přeloženou verzi stránky sám) a popup se otevře okamžitě, i offline.
 *
 * Titulek i velikost si nese <template> (data-popup-title, data-popup-size) — patří ke stránce,
 * ne k odkazu, takže se nemusí opakovat u každého spouštěče. Výchozí velikost je 'large'.
 *
 * Progresivní vylepšení: odkaz má pořád platné href na stránku. Bez JS (nebo když šablona chybí)
 * se preventDefault neuplatní a návštěvník prostě přejde na stránku.
 *
 * Popup samotný je třída Popup z global-popup.js (theme.liquid ji načítá dřív).
 */
(function () {
	if (window.__pagePopupBound) return;
	window.__pagePopupBound = true;

	document.addEventListener('click', function (udalost) {
		var spoust = udalost.target.closest('.js-page-popup');
		if (!spoust) return;
		if (typeof Popup === 'undefined') return;

		var sablona = document.getElementById(spoust.getAttribute('data-popup-template') || '');
		if (!sablona) return;

		udalost.preventDefault();

		var popup = new Popup(sablona.getAttribute('data-popup-size') || 'large', 'page-popup');
		var titulek = sablona.getAttribute('data-popup-title') || '';
		if (titulek) popup.setTitle('<h3 style="margin-bottom: 0;">' + titulek + '</h3>');

		var obal = document.createElement('div');
		obal.className = 'page-popup-content rte';
		obal.innerHTML = sablona.innerHTML;
		popup.setContent(obal);
		popup.show();
	});
})();
